export * from "./RedirectionLinkCard";
